import gql from 'graphql-tag'
import { fragPostSummary } from '../fragments/post.js'
import { fragPageInfo, fragSeoUserYoastFragment } from '../fragments/seo.js'
import { fragCptAdv } from '../fragments/advertising.js'

export const queryAuthorId = gql`
  query QueryAuthorId($nicename: String) {
    users(where: { nicename: $nicename }) {
      nodes {
        id
      }
    }
  }
`

export const queryAuthor = gql`
  ${fragPostSummary}
  ${fragPageInfo}
  ${fragSeoUserYoastFragment}
  query QueryAuthor(
    $idAuthor: ID!
    $startCursorAuthor: String
    $lastAuthor: Int
    $endCursorAuthor: String
    $firstAuthor: Int = 15
  ) {
    user(id: $idAuthor) {
      name
      description
      avatar {
        width
        height
        url
      }
      seo {
        ...FragSeoUserYoastFragment
        social {
          facebook
          instagram
          linkedIn
          youTube
        }
      }
      posts(
        before: $startCursorAuthor
        last: $lastAuthor
        after: $endCursorAuthor
        first: $firstAuthor
      ) {
        edges {
          node {
            ...FragPostSummary
          }
        }
        pageInfo {
          ...FragPageInfo
        }
      }
    }
  }
`

export const queryAuthorIntegration = gql`
  ${fragPostSummary}
  ${fragPageInfo}
  ${fragSeoUserYoastFragment}
  ${fragCptAdv}
  query QueryAuthorIntegration(
    $idAuthor: ID!
    $startCursorAuthor: String
    $lastAuthor: Int
    $endCursorAuthor: String
    $firstAuthor: Int = 15
    $uriPage: String
  ) {
    user(id: $idAuthor) {
      name
      description
      avatar {
        width
        height
        url
      }
      seo {
        ...FragSeoUserYoastFragment
        social {
          facebook
          instagram
          linkedIn
          youTube
        }
      }
      posts(
        before: $startCursorAuthor
        last: $lastAuthor
        after: $endCursorAuthor
        first: $firstAuthor
      ) {
        edges {
          node {
            ...FragPostSummary
          }
        }
        pageInfo {
          ...FragPageInfo
        }
      }
    }
    pageBy(uri: $uriPage) {
      advertising {
        acfAdv {
          ... on Advertising {
            advertisingType {
              cptAdv {
                ...FragCptAdv
              }
            }
          }
        }
      }
    }
  }
`
